import React from "react";
import { useEffect } from "react";
import $ from "jquery";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomInput from "../../Shared/CustomInput";
import { classOptions, codeOption, subjectOptions } from "../../utils/helpers";
import CustomSelect from "../../Shared/CustomSelect";
import SubmitForm from "../../Shared/SubmitForm";

const ClassRutine = () => {
  useEffect(() => {
    $(".checkAll").on("click", function () {
      $(this)
        .parents(".table")
        .find("input:checkbox")
        .prop("checked", this.checked);
    });
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Class Routine</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Routine</li>
        </ul>
      </div>

      <div class="row">
        <div class="col-4-xxxl col-12">
          <div class="card height-auto">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Add Class Routine</h3>
                </div>
                <Cta />
              </div>
              <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
                <div class="row">
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Subject Name *"}
                      register={register}
                      errors={errors}
                      name={"subjectname"}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject Type *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Select Subject"}
                      option={subjectOptions}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject Class *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Select Subject"}
                      option={classOptions}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject Code *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Select Subject"}
                      option={codeOption}
                    />
                  </div>
                  <SubmitForm />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-8-xxxl col-12">
          <div class="card height-auto">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Class Routine</h3>
                </div>
                <Cta />
              </div>
              <form class="mg-b-20">
                <div class="row gutters-8">
                  <div class="col-lg-4 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Day ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-3 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Class ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-3 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Section ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-2 col-12 form-group">
                    <button
                      type="submit"
                      class="fw-btn-fill btn-gradient-yellow"
                    >
                      SEARCH
                    </button>
                  </div>
                </div>
              </form>
              <div class="table-responsive">
                <table class="table display data-table text-nowrap">
                  <thead>
                    <tr>
                      <th>
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input checkAll"
                          />
                          <label class="form-check-label">Day</label>
                        </div>
                      </th>
                      <th>Class</th>
                      <th>Subject</th>
                      <th>Section</th>
                      <th>Teacher</th>
                      <th>Time</th>
                      <th>Date</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Sunday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>Accounting</td>
                      <td>A</td>
                      <td>Mike John</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Monday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>English</td>
                      <td>A</td>
                      <td>Adam John</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Tuesday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>Economics</td>
                      <td>A</td>
                      <td>Johanthon Ray</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Wednesday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>Drawing</td>
                      <td>A</td>
                      <td>Mike Jonas</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Thursday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>English</td>
                      <td>A</td>
                      <td>Kate Well</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Friday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>Chemistry</td>
                      <td>A</td>
                      <td>Mike John</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">Saturday</label>
                        </div>
                      </td>
                      <td>4</td>
                      <td>English</td>
                      <td>A</td>
                      <td>Mike John</td>
                      <td>10.00 am-11.00 am</td>
                      <td>20/06/2019</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassRutine;
